namespace advisorop.domains {

    export interface IXXCompanyGroup {
        id?: number;        
        name?: string;
        companyGroups?: Array<domains.CompanyGroup>;
    }

    export class XXCompanyGroup implements IXXCompanyGroup {


    }
}